import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { User, UserIgnoreList } from '../models/user.model';
import { GenericBaseService } from './generic-base.service';
import { UrlService } from "./url.service";

@Injectable({
  providedIn: 'root'
})

export class UserService extends GenericBaseService {

  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected url: UrlService
  ) {
    super('User', httpClient, toastrService, url);
  }

  resetPassword(id: string, customMessage?: string) {
    this.getNow('/users/resetPassword/' + id, null, null, customMessage)
  }

  resetPreSharedKey(userId: string, afterPostCallback?: Function, customMessage?: string) {
    this.postNow('/users/' + userId + '/reset-presharedkey', null, afterPostCallback, customMessage);
  }

  postUser(user: User, afterPostCallback?: Function, customMessage?: string) {
    this.post('/users', this.getBody(user, UserIgnoreList))
      .subscribe(
        (postedUser: User) => {
          if (afterPostCallback) {
            afterPostCallback();
          }

          if (postedUser.HasSendEmailError) {
            this.toastrService.warning(postedUser.SendEmailErrorMessage);
          }

          if (customMessage) {
            this.toastrService.success(customMessage);
          } else {
            this.toastrService.success("User added successfuly");
          }
        });
  }

  putUser(id: string, user: User, afterPutCallback?: Function, customMessage?: string) {
    return this.putNow('/users/' + id, this.getBody(user, UserIgnoreList), afterPutCallback, customMessage);
  }

  deleteUser(id: string, afterDeleteCallback?: Function) {
    return this.deleteNow('/users/' + id, afterDeleteCallback);
  }
}
